import React, { useEffect, useState } from 'react';
import './Preloader.css';
import logo from '../assests/logo-dark.png';

function Preloader({ onAnimationComplete }) {
  const [animationClass, setAnimationClass] = useState('zooming-in');

  useEffect(() => {
    // This sequence controls the animation timing
    const timer1 = setTimeout(() => {
      // After the initial zoom, start moving the logo to the corner
      setAnimationClass('moving-to-corner');
    }, 1500); // Wait 1.5s before moving

    const timer2 = setTimeout(() => {
      // After the move is complete, start fading out the whole screen
      setAnimationClass('moving-to-corner fading-out');
    }, 3000); // 1500ms wait + 1500ms move animation

    const timer3 = setTimeout(() => {
      // After the fade-out is complete, notify the app to show content
      onAnimationComplete();
    }, 3500); // 3000ms + 500ms fade animation

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, [onAnimationComplete]);

  return (
    <div className={`preloader-overlay ${animationClass}`}>
      <div className="preloader-logo-container">
        <img src={logo} alt="Degchi Logo" className="preloader-logo" />
      </div>
    </div>
  );
}

export default Preloader;

